import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { Global } from '../../global/global';
import { ChatMessage } from '../../models/chat-message.model';


@Injectable({
  providedIn: 'root'
})
export class MessagesService {


  constructor(private httpClient: HttpClient) { }

  public getMessages(senderId: string) {
    return this.httpClient.get<ChatMessage[]>(Global.BASE_API_URL + "/messages/from/" + senderId, { observe: 'body', responseType: 'json' })
  }

  public getMessage(id: string) {
    return this.httpClient.get<ChatMessage>(Global.BASE_API_URL + "/messages/" + id, { observe: 'body', responseType: 'json' })
  }

  public countMessages(senderId: string){
    return this.httpClient.get<number>(Global.BASE_API_URL + "/messages/from/" + senderId + "/count", { observe: 'body'})
  }



}
